// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"slider-module--wrapper--1W5OG","arrow":"slider-module--arrow--2Gv7t","mobile":"slider-module--mobile--1LZn-","desktop":"slider-module--desktop--1AOIF"};